import React from "react";
import { BrowserView, MobileOnlyView } from "react-device-detect";
import AppLayout from "../layout";
import { ExperiencesMobile } from "./mobile";

const Experiences = () => {
  return (
    <AppLayout>
      <BrowserView>
        <div className="experiences">
          <h1 className="title">MES EXPERIENCES</h1>
          <TimeLine />
        </div>
      </BrowserView>
      <MobileOnlyView>
        <ExperiencesMobile />
      </MobileOnlyView>
    </AppLayout>
  );
};

const TimeLine = () => {
  return (
    <div className="timeline">
      <div className="line-center"></div>
      <OneTimeLine
        date="Octobre 2020 - Mai 2021"
        compagny="BOKI TECH"
        job="Infographe et développeuse web/mobile"
      />
      <OneTimeLine
        revert={true}
        date="Janvier 2022 - Mai 2022"
        compagny="SANTECHSEN"
        job="Développeuse d’application"
      />
    </div>
  );
};

const OneTimeLine = ({ revert, date, compagny, job }) => {
  return (
    <div className={`one-timeline ${revert ? "revert" : ""}`}>
      <h4>{date}</h4>
      <div className="carre-deco"></div>
      <div className="line-v"></div>
      <div className="carre-deco-petit"></div>
      <h1>{compagny}</h1>
      <h2>{job}</h2>
    </div>
  );
};

export default Experiences;
